import { css } from "styled-components"
import { colors } from "../../helpers/colors"
import { BreakPoints, media } from "../../helpers/rwd"

export const FullSizeSliderWrapperStyle = css`
  .slick-dots {
    bottom: 30px;
  }

  border-bottom: 1px solid ${colors.yellow};

  .slick-slider {
    .slick-arrow {
      opacity: 0.9;
      border: 2px solid rgb(255, 203, 0);
      background: rgba(0,0,0,0.25);
      &.slick-prev {
        left: 10%;
        z-index: 1;
      }

      &.slick-next {
        right: 10%
      }
    }

    ul.slick-dots {
      bottom: 13px;

      li button:before {
        font-size: 8px
      }
    }
  }
  .slick-arrow.slick-arrow:hover {
    opacity: 1.0;
  }
  .slick-slider .slick-arrow::before {
    content: "";
    position: relative;
    font-size: 1px;
    display: block;
    width: 100%;
    height: 100%;
    background-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iNyIgdmlld0JveD0iMCAwIDEyIDciIGZpbGw9IiM3ODVEMUQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHBhdGggZD0iTTEuNzE0MjkgLTEuMDI4NjFlLTA2TDYgNC4zNzVMMTAuMjg1NyAtMS40MDMyOGUtMDZMMTIgMC44NzQ5OTlMNiA3TC0yLjY3NzMyZS0wNyAwLjg3NDk5OUwxLjcxNDI5IC0xLjAyODYxZS0wNloiIGZpbGw9IiNGRkNCMDAiLz4KPC9zdmc+Cgo=");
  }

  ${media.max(BreakPoints.lgDesktop)} {
    .slick-slider {
      .slick-arrow {
        &.slick-prev {
          left: 13px;
        }

        &.slick-next {
          right: 13px;
        }
      }
    }
  }

  ${media.max(BreakPoints.smallDesktop)} {
    .slick-slider {
      .slick-arrow {
        display: none !important;

        &.slick-prev {
          display: none;
        }

        &.slick-next {
          display: none;
        }
      }
    }
  }
`
export const FullSizeSlideWrapperStyle = css`
`
export const SlideHeaderLogoStyled = css`
  margin-bottom: 0;
  padding: 1px;
`
export const SlideContentInfoStyles = css`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  max-width: 1279px;
  width: 100%;
  padding: 0 61px;
  margin: 0 auto;

  ${media.max(BreakPoints.smallDesktop)} {
    max-width: 100%;
    margin-top: 13px;
    align-items: center;
    padding: 13px;
  }
`
export const SlideContentWrapperStyle = css`
  min-height: 660px;
  padding: 31px 0;

  ${media.max(BreakPoints.desktop)} {
    background-size: auto;
    background-position: center right;
  }

  ${media.max(BreakPoints.smallDesktop)} {
    background-size: auto 100%;
  }

  ${media.max(BreakPoints.tablet)} {
    background-size: auto auto;
    background-position: center center;
    margin: 0
  }
`
export const ButtonsListStyle = css`
  ${media.max(BreakPoints.tablet)} {
    flex-direction: column;
  }
`
export const ButtonWrapperStyle = css`
  margin-left: 20px;

  a {
    padding: 13px 13px 8px 13px;
  }

  ${media.max(BreakPoints.tablet)} {
    margin: 9px 0;
  }
`
export const TitleStyle = css`
  font-size: 3em;
  max-width: 450px;
  text-align: right;
  text-transform: uppercase;
  font-family: 'Roboto', sans-serif;
  font-weight: 900;
  text-shadow: 2px 2px 5px black;

  ${media.max(BreakPoints.smallDesktop)} {
    font-size: 45px;
    text-align: center;
    max-width: 90%;
  }

  ${media.max(BreakPoints.tablet)} {
    font-size: 35px;
  }

`
export const DescriptionStyle = css`
  font-size: 25px;
  padding: 3px 0 61px;
  max-width: 450px;
  text-align: right;
  text-transform: none;
  text-shadow: 1px 1px 1px black;

  ${media.max(BreakPoints.smallDesktop)} {
    font-size: 2em;
    text-align: center;
    padding: 3px 0 31px;
    max-width: 90%;
  }

  ${media.max(BreakPoints.tablet)} {
    font-size: 31px;
  }
`

